var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 9.9974C18.3307 14.5974 14.5974 18.3307 9.9974 18.3307C5.3974 18.3307 2.58906 13.6974 2.58906 13.6974M2.58906 13.6974H6.35573M2.58906 13.6974V17.8641M1.66406 9.9974C1.66406 5.3974 5.36406 1.66406 9.9974 1.66406C15.5557 1.66406 18.3307 6.2974 18.3307 6.2974M18.3307 6.2974V2.13073M18.3307 6.2974H14.6307",
    stroke: "url(#paint0_linear_14322_17295)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14322_17295",
    x1: 2.86005,
    y1: -2.35379,
    x2: 18.728,
    y2: -0.774144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.689e39e29cfb580b5cefee0e5b2a7328.svg";
export { ForwardRef as ReactComponent };